export default "__VITE_ASSET__4ad6e30a__"